import React, {useContext, useRef, useState, useCallback} from 'react';
import {useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {controlType, formBodyType, entities} from '../../../../../../../util/uiconstants';
import StyledBodySpecialAccordionContentListItem from '../StyledBodySpecialAccordionContentListItem';
import StyledBodySpecialGridPrimaryColumn from '../StyledBodySpecialGridPrimaryColumn';
import StyledBodySpecialGridSecondaryColumn from '../StyledBodySpecialGridSecondaryColumn';
import {getItApplicationById, getAllControls} from '../../../../../../../selectors/ISA315/selectors';
import Utility from '../../../../../../../util/utilityfunctions';
import Ellipses from '../../../../../EllipsesControl/EllipsesPresets';
import CreateUpdateEntityContainer from '../../../../../CanvasForm/Bodies/BodyTypes/BodySpecial/CreateUpdateEntities/CreateUpdateEntityContainer';
import {useDocumentId, useEngagementId} from '../../../../../../../util/customHooks';
import {DocumentEngagementIdContext} from '../../../../../../Main/Forms/CanvasFormContainer';

function ISA315ScotItApplicationAccordionItem({itAppId, scotId}) {
	const scot = useSelector((state) => state.bodiesSpecial.scots.byId[scotId]);
	const itApplication = useSelector((state) => getItApplicationById(state, itAppId));
	const allControls = useSelector(getAllControls);
	const engagementId = useEngagementId();
	const documentId = useDocumentId();
	const documentEngagementId = useContext(DocumentEngagementIdContext);
	const modalRef = useRef();
	const [containerProps, setContainerProps] = useState({});

	const controlTypes = [controlType.itApplicationControl, controlType.itDependentManualControl];

	let counters = {
		[controlType.itApplicationControl]: 0,
		[controlType.itDependentManualControl]: 0
	};

	scot.controls.forEach((ctrlId) => {
		const control = allControls.find((ctrl) => ctrl.id === ctrlId);

		if (
			control?.itApplications &&
			control.itApplications.length > 0 &&
			controlTypes.indexOf(control.controlTypeId) !== -1
		) {
			if (control.itApplications.indexOf(itAppId) !== -1) {
				counters[control.controlTypeId]++;
			}
		}
	});

	const onNameClick = () => {
		onITAppNameClick({
			...itApplication,
			entityId: entities.ItSoApplication,
			entityName: itApplication.itApplicationName,
			entityUId: itApplication.id
		});
	};

	const onITAppNameClick = useCallback(
		(args) => {
			if (modalRef.current.toggleModal) {
				setContainerProps(args);
				modalRef.current.toggleModal();
			}
		},
		[modalRef]
	);

	return (
		<StyledAccordionContentListItemRow className="StyledAccordionContentListItemRow">
			<StyledItApplicationColumn className="StyledItApplicationColumn">
				<StyledBodySpecialGridPrimaryColumn className="StyledBodySpecialGridPrimaryColumn">
					<span className="StyledBodySpecialGridPrimaryColumnText" onClick={onNameClick}>
						<Ellipses.Single>{itApplication.itApplicationName}</Ellipses.Single>
					</span>
				</StyledBodySpecialGridPrimaryColumn>
			</StyledItApplicationColumn>
			<StyledCountColumnRelatedITApps className="StyledCountColumnRelatedITApps" />
			<StyledCountColumnApplication className="StyledCountColumnApplication">
				<StyledBodySpecialGridSecondaryColumn className="StyledBodySpecialGridSecondaryColumn">
					{Utility.showISA315Counter(counters[controlType.itApplicationControl])}
				</StyledBodySpecialGridSecondaryColumn>
			</StyledCountColumnApplication>
			<StyledCountColumnITDM className="StyledCountColumnITDM">
				<StyledBodySpecialGridSecondaryColumn className="StyledBodySpecialGridSecondaryColumn">
					{Utility.showISA315Counter(counters[controlType.itDependentManualControl])}
				</StyledBodySpecialGridSecondaryColumn>
			</StyledCountColumnITDM>
			<CreateUpdateEntityContainer
				{...containerProps}
				engagementId={engagementId}
				documentId={documentId}
				documentEngagementId={documentEngagementId}
				bodyTypeId={formBodyType.ISA315ScotItApplication}
				ref={modalRef}
			/>
		</StyledAccordionContentListItemRow>
	);
}

ISA315ScotItApplicationAccordionItem.propTypes = {
	itAppId: PropTypes.number.isRequired
};

export default ISA315ScotItApplicationAccordionItem;

const StyledAccordionContentListItemRow = styled(StyledBodySpecialAccordionContentListItem)`
	border-top: var(--px-1) solid var(--neutrals-200);
	border-bottom: unset;
`;

const StyledItApplicationColumn = styled.section`
	width: calc(100% - var(--px-380));
	.StyledBodySpecialGridPrimaryColumnText {
		cursor: pointer;
		.ellipses {
			width: auto;
		}
		&:hover {
			.ellipses {
				text-decoration: underline;
			}
		}
	}
`;

const StyledCountColumnRelatedITApps = styled.section`
	width: var(--px-120);
	padding: 0 var(--px-10) 0 0 !important;
	margin-left: var(--px-20);
`;

const StyledCountColumnApplication = styled.section`
	width: var(--px-120);
	padding: 0 var(--px-10) 0 0 !important;
`;

const StyledCountColumnITDM = styled.section`
	width: var(--px-90);
	padding: 0 0 0 var(--px-10) !important;
`;
